import Phaser from 'phaser';
import { TOAST, BOUNDS } from '../config/constants';

export class Toast extends Phaser.Physics.Arcade.Sprite {
  private rotationSpeed: number;

  constructor(
    scene: Phaser.Scene,
    x: number,
    y: number,
    group: Phaser.Physics.Arcade.Group
  ) {
    super(scene, x, y, 'toast');
    
    // Add to scene and group
    scene.add.existing(this);
    group.add(this);
    
    // Enable physics
    scene.physics.add.existing(this);
    
    // Set velocity upward
    this.setVelocityY(-TOAST.SPEED);
    
    // Random slight rotation for visual interest
    this.rotationSpeed = Phaser.Math.FloatBetween(-0.05, 0.05);
    
    // Set up physics body size
    const body = this.body as Phaser.Physics.Arcade.Body;
    body.setSize(TOAST.WIDTH - 4, TOAST.HEIGHT - 4);
  }

  update(): void {
    // Spin the toast slightly as it flies
    this.rotation += this.rotationSpeed;
    
    // Destroy if off screen
    if (this.y < BOUNDS.TOP - 20) {
      this.destroy();
    }
  }
}






